export default __webpack_public_path__ + "static/media/learn-osm-logo.3e8b56aa.svg";